import IF from '@/components/IF';
import { updateVariableToUm, updateWeatherHierchydata } from '@/redux/reducer/weatherStation';
import { weatherGetHierarchy } from '@/util/Request';
import { Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import './index.less';
import { RootState } from '@reduxjs/toolkit';

interface IProps {
    show: boolean
    hideCallback: (selectedItem?: ISelectedProps) => void
}

interface ISelectedProps {
    supplier: string
    stationId?: string
    variable: string
    frequency: string
    selected: boolean
    showSelected: string
    variableName: string
    level: string
    aggregation: string
    isActive: boolean
    hierarchyId: number
    um: string
    latitude?: string
    longitude?: string
    station?: {
        stationID: string
        latitude: string
        longitude: string
        variables: string[]
    }
}

interface IFifthLevelDataModel {
    aggregation: string
    um: string
    hierarchyId: number
}

const SoilSupplierPropertiesComponent = (props: IProps) => {
    const {
        show,
        hideCallback
    } = props;

    const [showMenu, setShowMenu] = useState(false);
    const [firstLevelData, setFirstLevelData] = useState<string[]>([]);
    const [secondLevelData, setSecondLevelData] = useState<string[]>([]);
    const [thirdLevelData, setThirdLevelData] = useState<string[]>([]);
    const [fourthLevelData, setFourthLevelData] = useState<string[]>([]);
    const [fifthLevelData, setFifthLevelData] = useState<string[]>([]);

    const [variableMapObj, setVariableMapObj] = useState({});

    const [secondAvaliableList, setSecondAvaliableList] = useState<string[]>([]);
    const [thirdAvaliableList, setThirdAvaliableList] = useState<string[]>([]);
    const [fourthAvaliableList, setFourthAvaliableList] = useState<string[]>([]);
    const [fifthAvaliableList, setFifthAvaliableList] = useState<IFifthLevelDataModel[]>([]);
    const [menuObj, setMenuObj] = useState<unknown>();

    const [secondLevelShow, setSecondLevelShow] = useState<boolean>(false);
    const [thirdLevelShow, setThirdLevelShow] = useState<boolean>(false);
    const [fourthLevelShow, setFourthLevelShow] = useState<boolean>(false);
    const [fiftheLevelShow, setFifthLevelShow] = useState<boolean>(false);

    const [firstLevelSelected, setFirstLevelSelected] = useState<string | null>(null);
    const [secondLevelSelected, setSecondLevelSelected] = useState<string | null>(null);
    const [thirdLevelSelected, setThirdLevelSelected] = useState<string | null>(null);
    const [fourthLevelSelected, setFourthLevelSelected] = useState<string | null>(null);

    const [loading, setLoading] = useState(false);

    const domRef = useRef(null);

    const dispatch = useDispatch();

    const {
        weatherHierchyData
    } = useSelector((state: RootState) => state.weatherStation);

    const requestWeatherPropertiesData = async () => {
        try {
            let data;
            if (weatherHierchyData) {
                data = weatherHierchyData;
            } else {
                setLoading(true);
                data = await weatherGetHierarchy();
                dispatch(updateWeatherHierchydata(data));
            }
            const constructMenuData = {};
            const hierarchies = data.hierarchies;
            let newVariableMap:{ string: string };
            let variableMapToUm;
            for (const weatherPropertyData of hierarchies) {
                const {
                    supplier,
                    variable,
                    variableName,
                    frequency,
                    level,
                    aggregation,
                    um,
                    hierarchyId,
                    isActive
                } = weatherPropertyData;
                if (!isActive) {
                    continue;
                }
                if (!variableMapToUm) {
                    variableMapToUm = { [variable]: um };
                } else {
                    variableMapToUm[variable] = um;
                }

                newVariableMap = { ...newVariableMap, [variable]: variableName };
                setVariableMapObj(newVariableMap);

                if (!constructMenuData[supplier]) {
                    constructMenuData[supplier] = {[variable]: {[level]: { [frequency]: [{aggregation, um, hierarchyId}]}}};
                    continue;
                }
                if (!constructMenuData[supplier][variable]) {
                    constructMenuData[supplier] = { ...constructMenuData[supplier], [variable]:{ [level]: { [frequency]: [{aggregation, um, hierarchyId}] }}};
                    continue;
                }

                if (!constructMenuData[supplier][variable][level]) {
                    constructMenuData[supplier][variable] = { ...constructMenuData[supplier][variable], [level]: { [frequency]: [{aggregation, um, hierarchyId}]}} ;
                    continue;
                }

                if (!constructMenuData[supplier][variable][level][frequency]) {
                    constructMenuData[supplier][variable][level] = { ...constructMenuData[supplier][variable][level], [frequency]: [{aggregation, um, hierarchyId}] } ;
                } else {
                    constructMenuData[supplier][variable][level][frequency].push({aggregation, um, hierarchyId});
                }
            }
            setVariableMapObj(newVariableMap);
            setFirstLevelData(data.metadata.supplier);
            setSecondLevelData(data.metadata.variable);
            setThirdLevelData(data.metadata.level);
            setFourthLevelData(data.metadata.frequency);
            setFifthLevelData(data.metadata.aggregation);
            setMenuObj(constructMenuData);
            setLoading(false);
            dispatch(updateVariableToUm(variableMapToUm));
        } catch(err) {
            setLoading(false);
        }
    };

    useEffect(() => {
        requestWeatherPropertiesData();
    }, []);

    useEffect(() => {
        if (show) {
            const dom = document.createElement('div');
            dom.setAttribute('id', 'supplier-custome-component');
            dom.style.zIndex = '6666';
            document.body.appendChild(dom);
            domRef.current = dom;
            setShowMenu(true);
        } else {
            setShowMenu(false);
            resetState();
        }
    }, [show]);

    const localRef = useRef(null);

    document.addEventListener('click',e => {
        if(localRef && localRef.current && !localRef.current.contains(e.target)) {
            hideCallback && hideCallback();
            setShowMenu(false);
        }
    });

    const resetState = () => {
        const element = document.getElementById('supplier-custome-component');
        if (element) {
            document.body.removeChild(element);
        }
        setSecondLevelSelected(null);
        setThirdLevelSelected(null);
        setFourthLevelSelected(null);
        setFirstLevelSelected(null);
    };

    const firstLevelItemClick = (firstLevelSelected: string) => {
        const secondLevelData = menuObj[firstLevelSelected];
        const avaliableList = Object.keys(secondLevelData);
        setFirstLevelSelected(firstLevelSelected);
        setSecondAvaliableList(avaliableList);
        setThirdLevelSelected(null);
        setFourthLevelSelected(null);
    };

    const secondLevelItemClick = (secondLevelSelcted: string) => {
        const thirdLevelData = menuObj[firstLevelSelected][secondLevelSelcted];
        const avaliableList = Object.keys(thirdLevelData);
        setSecondLevelSelected(secondLevelSelcted);
        setThirdAvaliableList(avaliableList);
        setThirdLevelSelected(null);
        setThirdLevelSelected(null);
        setFourthLevelSelected(null);
    };

    const thirdLevelItemClick = (thirdLevelSelected: string) => {
        const fourthLevelData = menuObj[firstLevelSelected][secondLevelSelected][thirdLevelSelected];
        const avaliableList = Object.keys(fourthLevelData);
        setThirdLevelSelected(thirdLevelSelected);
        setFourthAvaliableList(avaliableList);
        setFourthLevelSelected(null);
    };

    const fourthLevelItemClick = (fourthLevelSelected: string) => {
        const fifthLevelData = menuObj[firstLevelSelected][secondLevelSelected][thirdLevelSelected][fourthLevelSelected];
        setFourthLevelSelected(fourthLevelSelected);
        setFifthAvaliableList(fifthLevelData);
    };

    const fifthLevelItemClick = (localFifthLevelSelected: IFifthLevelDataModel) => {
        const obj: ISelectedProps = {
            supplier: firstLevelSelected,
            variable: secondLevelSelected,
            frequency: fourthLevelSelected,
            showSelected: `${firstLevelSelected}/${variableMapObj[secondLevelSelected]}/${thirdLevelSelected}/${fourthLevelSelected}/${localFifthLevelSelected.aggregation}`,
            selected: true,
            variableName: `${variableMapObj[secondLevelSelected]}`,
            level: thirdLevelSelected,
            aggregation: localFifthLevelSelected.aggregation,
            isActive: true,
            um: localFifthLevelSelected.um,
            hierarchyId: localFifthLevelSelected.hierarchyId
        };
        hideCallback(obj);
    };

    useEffect(() => {
        if (firstLevelSelected) {
            setSecondLevelShow(true);
        } else {
            setSecondLevelShow(false);
        }
        setThirdLevelShow(false);
        setFourthLevelShow(false);
        setFifthLevelShow(false);
    }, [firstLevelSelected]);

    useEffect(() => {
        if (secondLevelSelected) {
            setSecondLevelShow(true);
            setThirdLevelShow(true);
            setFourthLevelShow(false);
            setFifthLevelShow(false);
        }
    }, [secondLevelSelected]);

    useEffect(() => {
        if (thirdLevelSelected) {
            setThirdLevelShow(true);
            setFourthLevelShow(true);
            setFifthLevelShow(false);
        }
    }, [thirdLevelSelected]);

    useEffect(() => {
        if (fourthLevelSelected) {
            setFourthLevelShow(true);
            setFifthLevelShow(true);
        }
    }, [fourthLevelSelected]);

    return (showMenu ? createPortal(
        <div ref={localRef} className='soil-supplier-properties-component-super-div'>
            <div className='first-level-div'>
                <Spin spinning={loading}>
                    <span className='title-span'>Supplier</span>
                    {firstLevelData.map((firstLevelItem) => (
                        <button
                            className={'menu-item-div-super'}
                            key={firstLevelItem}
                            onClick={() => firstLevelItemClick(firstLevelItem)}
                        >
                            <span className={`${firstLevelItem === firstLevelSelected && 'menu-item-div-super-selected'}`} >{firstLevelItem}</span>
                        </button>
                    ))}
                </Spin>
            </div>
            <IF show={secondLevelShow}>
                <div className='second-level-div'>
                    <span className='title-span'>Property</span>
                    {secondLevelData.map((secondLevelItem) => {
                        const include = secondAvaliableList.includes(secondLevelItem);
                        return (
                            <button className='menu-item-div-super' key={secondLevelItem} onClick={() => include && secondLevelItemClick(secondLevelItem)}>
                                <span className={`${include ? 'avalible' : 'unavalible'} ${secondLevelItem === secondLevelSelected && 'menu-item-div-super-selected'}`}>{variableMapObj[secondLevelItem]}</span>
                            </button>
                        );
                    })}
                </div>
            </IF>
            <IF show={thirdLevelShow}>
                <div className='third-level-div'>
                    <span className='title-span'>Level</span>
                    {thirdLevelData.map((thirdLevelItem) => {
                        const include = thirdAvaliableList.includes(thirdLevelItem);
                        return (
                            <button className={'menu-item-div-super'} key={thirdLevelItem} onClick={() => include && thirdLevelItemClick(thirdLevelItem)}>
                                <span className={`${include ? 'avalible' : 'unavalible'} ${thirdLevelItem === thirdLevelSelected && 'menu-item-div-super-selected'}`} key={thirdLevelItem}>{thirdLevelItem}</span>
                            </button>
                        );
                    }
                    )}
                </div>
            </IF>
            <IF show={fourthLevelShow}>
                <div className='fourth-level-div'>
                    <span className='title-span'>Frequency</span>
                    {fourthLevelData.map((fourthLevelItem) => {
                        const include = fourthAvaliableList.includes(fourthLevelItem);
                        return (
                            <button className={'menu-item-div-super'} key={fourthLevelItem} onClick={() => include && fourthLevelItemClick(fourthLevelItem)}>
                                <span className={`${include ? 'avalible' : 'unavalible'} ${fourthLevelItem === fourthLevelSelected && 'menu-item-div-super-selected'}`} key={fourthLevelItem}>{fourthLevelItem}</span>
                            </button>
                        );
                    })}
                </div>
            </IF>
            <IF show={fiftheLevelShow}>
                <div className='fifth-level-div'>
                    <span className='title-span'>Aggretion</span>
                    {fifthLevelData.map((fifthLevelItem) => {
                        const include = fifthAvaliableList.filter((element) => element.aggregation == fifthLevelItem);
                        return (
                            <button className='menu-item-div-super' key={fifthLevelItem} onClick={() => fifthLevelItemClick(include[0])}>
                                <span className={`${include.length > 0 ? 'avalible' : 'unavalible'}`} key={fifthLevelItem}>{fifthLevelItem}</span>
                            </button>
                        );
                    })}
                </div>
            </IF>
        </div>, domRef.current) : null
    );
};

export type {
    ISelectedProps
};

export default SoilSupplierPropertiesComponent;